<div class="card border-primary ui-g" style="display: block; padding: .5em;">
    <!-- <div class="ui-g-12"> -->
        <div class="ui-g ui-fluid">

        <!-- <p-table 
        class="ui-g-12" 
        [value]="tablaCursos" 
        [(selection)]="selCurso" 
        dataKey="codAuditoria"
        selectionMode="single"
        [responsive]="true"
        autoLayout="true"
        [paginator]="true" 
        [rows]="7" 
        [totalRecords]="listCount"
        [lazy]="true"
        (onLazyLoad)="onPage($event)"
        (onRowSelect)="onRowSelect($event)"
        > -->

        <p-table class="ui-g-12" [value]="listCapacitacion" [responsive]="true" autoLayout="true" [paginator]="true"  (sortFunction)="customSort($event)" [customSort]="true" [rows]="7" >

            <ng-template pTemplate="caption">
                Perfil de capacitación
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th style="width:40%" pSortableColumn="tema">Tema <p-sortIcon field="name"></p-sortIcon></th>
                    <!-- <th style="width:20%">Fecha de vencimiento</th>
                    <th style="width:20%">Estado</th> -->
                    <th style="width:20%" pSortableColumn="fechaVen">Fecha de vencimiento <p-sortIcon field="name"></p-sortIcon></th>
                    <th style="width:20%" pSortableColumn="estado">Estado <p-sortIcon field="category"></p-sortIcon></th>
                    <th style="width:10%" pSortableColumn="nota">Nota <p-sortIcon field="category"></p-sortIcon></th>
                    <th style="width:10%">Certificado</th>


                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-Perfil>
                <tr [pSelectableRow]="Perfil">
                    <td><span class="ui-column-title">Tema</span>{{Perfil.tema}}</td>
                    <td><span class="ui-column-title">Fecha de vencimiento</span>{{formatoFecha(Perfil.fechaVen)}}</td>
                    <td><span class="ui-column-title">Estado</span>{{Perfil.estado}}</td>
                    <td><span class="ui-column-title">Nota</span>{{Perfil.nota}}</td>
                    <td>
                        <button [disabled]="!Perfil.certificado" type="button" pButton icon="pi pi-download"
                            (click)="DescargarCertificado(Perfil)" class="ui-button-info"></button>
                    </td>


                </tr>
            </ng-template>
        </p-table>
    </div>
</div>